import React from 'react'
import { Container,Navbar,Nav } from 'react-bootstrap';
import { LinkContainer } from "react-router-bootstrap";
function Header() {
    return (
        <header>
            <Navbar bg="dark" expand="lg" variant="dark" >
                <Container>
                    <LinkContainer to="/">
                    <Navbar.Brand>ProShop</Navbar.Brand>
                    </LinkContainer>
                    <Navbar.Toggle aria-controls="basic-navbar-nav"/>
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="ms-auto">
                            <LinkContainer to="/cart">
                                <Nav.Link><i className="fas fa-shopping-cart me-1"></i>Cart</Nav.Link>
                            </LinkContainer>
                            <LinkContainer to="/login">
                                <Nav.Link href="/login"><i className="fas fa-user me-1"></i>Sign In</Nav.Link>
                            </LinkContainer>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </header>
    )
}

export default Header
